import React, { useEffect, useState } from 'react';
import { TextField, Select, MenuItem, RadioGroup, FormControlLabel, Radio } from '@mui/material';
// import InputContainer from '../../layout/inputContainer';
import { useForm } from "react-hook-form";
import { paymentStatus, registryStatus, uptodatePaymentStatus, yesOrNo } from '../../data';
import { useDispatch } from 'react-redux';
import { updateChecklistFormField } from '@egovernments/digit-ui-module-core/src/redux/actions/ownerEMOChecklist';
import { Table } from "react-bootstrap";
import ButtonWrapper from '../../components/Button';
import useModal from '@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal';


const LTPCheckList = ({formData}) => {
    const sessionData = JSON.parse(sessionStorage.getItem("ltpCheckList"))
    const defaultValues = {
        ...sessionData,  
    };
    const { handleSubmit, control, reset, watch } = useForm({defaultValues});
    const dispatch = useDispatch();
    const [isPossessionAreaDiff, setIsPossessionAreaDiff] = useState("");
    const [regStatus, setregStatus] = useState("");
    const [storedData, setStoredData] = useState(null);
    const Modal = useModal()
    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateChecklistFormField(name, value));
        if (name === 'isPossesionAreaDiff') {
            setIsPossessionAreaDiff(value);
        } else if (name === 'registryStatus') {
            setregStatus(value)
        }
    };
    const onSubmit = (data) => {
        console.log(data, "data while submitting");
        Modal(
            "Checklist updated.",
            `Checklist Updated Successfully!`,
            "success",
          );
    };

    useEffect(() => {
        const storedChecklist = JSON.parse(sessionStorage.getItem("ltpCheckList"));
        if (storedChecklist) {
            setStoredData(storedChecklist);
        }
    }, []);

    console.log(storedData, "storedDataaaaa");
    return (
        <section className="groupContainer">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer" style={{ marginRight: '200px' }}>
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">
                        Check list for the registration of LTP
                        </h2>
                    </div>
                    <div className="formInputContainer">
                        <Table striped bordered className="m-0" >
                                {/*if ARCHITECT */}
                                {formData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType?.split('.')[0] === "ARCHITECT" && (
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Does the applicant have the minimum qualifications as provided under the Architects Act, 1972 for the registration with the Council of Architecture</td>
                                    <td>
                                     <RadioGroup
                                            name="theminimumqualifications"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theminimumqualifications || formData?.nocOtherDetails?.theminimumqualifications}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Is the applicant Registered with the Council of Architecture</td>
                                    <td>
                                     <RadioGroup
                                            name="theapplicantRegistered"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theapplicantRegistered || formData?.nocOtherDetails?.theapplicantRegistered}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Does the applicant possess a valid COA Registration Number</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantPossess"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantPossess || formData?.nocOtherDetails?.theApplicantPossess}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Is the applicant’s COA License/Membership valid for the period mentioned in the application </td>
                                    <td>
                                     <RadioGroup
                                            name="thelicenseMembership"
                                            onChange={handleChange}
                                            defaultValue={storedData?.thelicenseMembership || formData?.nocOtherDetails?.thelicenseMembership}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
{/*                                 
                                <tr>
                                    <td>2</td>
                                    <td>Registry/Agreement Status</td>
                                    <td>
                                        <Select
                                            label="Payment Status"
                                            name="registryStatus"
                                            onChange={handleChange}
                                            placeholder='Registry Status'
                                            fullWidth
                                            defaultValue={storedData?.registryStatus || null}
                                        >
                                            {registryStatus.map((status) => (
                                                <MenuItem key={status.value} value={status.value}>
                                                    {status.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr>
                                {regStatus === 'Done' && (
                                    <tr>
                                        <td>3</td>
                                        <td>Registry/Agreement Date</td>
                                        <td>
                                            <TextField
                                                label="Registry/Agreement Date"
                                                name="agreementDate"
                                                type="date"
                                                InputLabelProps={{ shrink: true }}
                                                onChange={handleChange}
                                                fullWidth
                                                defaultValue={storedData?.agreementDate || null}
                                            />
                                        </td>
                                    </tr>
                                )}
                                <tr>
                                    <td>4</td>
                                    <td>Payment Status</td>
                                    <td>
                                        <Select
                                            label="Payment Status"
                                            name="paymentStatus"
                                            onChange={handleChange}
                                            placeholder='Payment Status'
                                            fullWidth
                                            defaultValue={storedData?.paymentStatus || null}
                                        >
                                            {paymentStatus.map((status) => (
                                                <MenuItem key={status.value} value={status.value}>
                                                    {status.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Up-to-date Payment Status</td>
                                    <td>
                                        <Select
                                            label="Up-to-date Payment Status"
                                            name="uptodatePaymentStatus"
                                            onChange={handleChange}
                                            placeholder='Uptodate Payment Status'
                                            fullWidth
                                            defaultValue={storedData?.uptodatePaymentStatus || null}
                                        >
                                            {uptodatePaymentStatus.map((status) => (
                                                <MenuItem key={status.value} value={status.value}>
                                                    {status.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>Is Possession Area Different from Allotment</td>
                                    <td>
                                        <RadioGroup
                                            name="isPossesionAreaDiff"
                                            onChange={handleChange}
                                            defaultValue={storedData?.isPossesionAreaDiff || null}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                {isPossessionAreaDiff === 'yes' && (
                                    <tr>
                                        <td>7</td>
                                        <td>Area of Extra Land Allotted</td>
                                        <td>
                                            <TextField
                                                label="Area of Extra Land Allotted"
                                                name="areaOfExtraLand"
                                                placeholder='Area of Extra Land'
                                                type="text"
                                                onChange={handleChange}
                                                fullWidth
                                                defaultValue={storedData?.areaOfExtraLand || null}
                                            />
                                        </td>
                                    </tr>
                                )} */}
                            </tbody>
                            )}
                            {/*if Engineer */}
                                {formData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType?.split('.')[0] === "GRADUATECIVILENGINEER" && (
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Is the applicant a graduate in civil engineering / Architectural Engineering from a recognized Indian or foreign university</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantGraduate"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantGraduate || formData?.nocOtherDetails?.theApplicantGraduate}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Is the applicant a member of IEI, or the statutory body governing such profession, as and when established </td>
                                    <td>
                                     <RadioGroup
                                            name="theapplicantMember"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theapplicantMember || formData?.nocOtherDetails?.theapplicantMember}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Does the applicant possess a valid IEI registration number </td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantPossess"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantPossess || formData?.nocOtherDetails?.theApplicantPossess}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Is the applicant’s IEI license/membership valid for the period mentioned in the application   </td>
                                    <td>
                                     <RadioGroup
                                            name="thelicenseMembership"
                                            onChange={handleChange}
                                            defaultValue={storedData?.thelicenseMembership || formData?.nocOtherDetails?.thelicenseMembership}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                            </tbody>
                            )}
                            {/*if Structural Engineer */}
                                {formData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType?.split('.')[0] === "STRUCTURALENGINEER" && (
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Is the applicant a graduate in civil engineering from a recognized Indian or foreign university, or the member of civil engineers (India) </td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantGraduate"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantGraduate || formData?.nocOtherDetails?.theApplicantGraduate}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Does the applicant have 2 years of experience in the case of postgraduate degree in structural engineering from a recognized Indian or foreign university</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantTwoYears"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantTwoYears || formData?.nocOtherDetails?.theApplicantTwoYears}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Does the applicant have 1 year of experience in the case of doctorate in Structural Engineering</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantOneYears"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantOneYears || formData?.nocOtherDetails?.theApplicantOneYears}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Does the applicant possess a valid registration number from IEI / member of civil engineers </td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantPossessValid"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantPossessValid || formData?.nocOtherDetails?.theApplicantPossessValid}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Is the applicant’s license/membership valid for the period mentioned in the application</td>
                                    <td>
                                     <RadioGroup
                                            name="thelicenseMembership"
                                            onChange={handleChange}
                                            defaultValue={storedData?.thelicenseMembership || formData?.nocOtherDetails?.thelicenseMembership}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                            </tbody>
                            )}
                            {/*if Supervisor */}
                            {formData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType?.split('.')[0] === "SUPERVISOR" && (
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Does the applicant hold a diploma in civil engineering or architectural assistantship</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantHold"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantHold || formData?.nocOtherDetails?.theApplicantHold}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Does the applicant have qualifications in architecture or engineering equivalent to the minimum qualification prescribed the recruitment to non-gazetted service by the Government of India</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantQualifications"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantQualifications || formData?.nocOtherDetails?.theApplicantQualifications}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Does the applicant have 5 Years of experience in building design, construction, and supervision</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantFiveYears"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantFiveYears || formData?.nocOtherDetails?.theApplicantFiveYears}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                {/* <tr>
                                    <td>4</td>
                                    <td>Is the applicant’s CoA license/membership valid for the period mentioned in the application </td>
                                    <td>
                                     <RadioGroup
                                            name="thelicenseMembership"
                                            onChange={handleChange}
                                            defaultValue={storedData?.thelicenseMembership || null}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr> */}
                            </tbody>
                            )}
                            {/*if Town Planner */}
                            {formData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType?.split('.')[0] === "TOWNPLANNER" && (
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Does the applicant have a graduate or postgraduate degree in town and country planning</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantGraduate"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantGraduate || formData?.nocOtherDetails?.theApplicantGraduate}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Does the applicant have Associate membership of the Institute of Town Planners, India</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantAssociateMembership"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantAssociateMembership || formData?.nocOtherDetails?.theApplicantAssociateMembership}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Does the applicant have a valid ITPI membership number</td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantITPI"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantITPI || formData?.nocOtherDetails?.theApplicantITPI}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Is the applicant’s ITPI membership valid for the period mentioned in the application </td>
                                    <td>
                                     <RadioGroup
                                            name="theApplicantITPImembership"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theApplicantITPImembership || formData?.nocOtherDetails?.theApplicantITPImembership}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                            </tbody>
                            )}
                            {/*if Landscape Architect */}
                            {formData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType?.split('.')[0] === "LANDSCAPEARCHITECT" && (
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Does the applicant have a bachelor’s or master’s degree in landscape architecture or equivalent from a recognized Indian or foreign university</td>
                                    <td>
                                     <RadioGroup
                                            name="theLandscapeArchitecture"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theLandscapeArchitecture || formData?.nocOtherDetails?.theLandscapeArchitecture}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                             </tbody>
                            )}
                            {/*if Urban Designer */}
                            {formData?.tradeLicenseDetail?.tradeUnits?.[0]?.tradeType?.split('.')[0] === "URBANDESIGNER" && (
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Does the applicant have a master’s degree in urban design or equivalent from a recognized Indian or foreign university </td>
                                    <td>
                                     <RadioGroup
                                            name="theDegreeUrbanDesign"
                                            onChange={handleChange}
                                            defaultValue={storedData?.theDegreeUrbanDesign || formData?.nocOtherDetails?.theDegreeUrbanDesign}
                                        >
                                            {yesOrNo.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={option.value}
                                                    control={<Radio />}
                                                    label={option.label}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </td>
                                </tr>
                                </tbody>
                            )}
                             </Table>
                    </div>
                </div>
                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <div style={{marginRight:"15%"}}>
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                            />
                        </div>
                         </div>
                </div>
            </form>
        </section>
    );
};

export default LTPCheckList;
